























































































































































































































































































































import Vue from "vue";

import { default as moment } from "moment-timezone";

import { isComputer } from "@/service/DeviceType";

import {
  Termin,
  Dame,
  MassageArt,
  massagearten,
  PopoverMode,
} from "@/api/Termine";
import { berechneMiete, vollerPreisDesTermins } from "../api/Abrechnung";

export interface TerminUpdateEvent {
  popoverMode: PopoverMode;
  termin: Termin;
}

export default Vue.extend({
  name: "BelegungsplanPopover",
  props: { verfuegbareDamen: { type: Array, required: true } },
  data() {
    return {
      // Konstante Daten
      massagearten,

      // Einstellungen für Popover-Dialog
      popoverMode: "info" as PopoverMode,
      popoverTitle: "",
      popoverHinweistext: "",
      isMobile: false,
      damenGefiltert: [] as Dame[],
      popoverYesSaveButtonLabel: "",
      showPopover: false,

      // Termindetails
      gast: "",
      dame: null as Dame | null,
      dame2: null as Dame | null,
      massageart: {} as MassageArt,
      termin: null as Termin | null,
      zeitLabel: "",
      tag: "",
      zeit: new Date(),
      originalUhrzeit: undefined as string | undefined,
      minDate: new Date(),
      maxDate: new Date(),
      dauer: new Date(),
      minDauerDate: new Date(),
      maxDauerDate: new Date(),
      minDuration: isComputer() ? 30 : 15,
      maxDuration: isComputer() ? 240 : 255,
      preisManuell: "",
      zimmermieteManuell: 0,
      verdienstDame: 0,
    };
  },
  computed: {
    terminBlockierung() {
      const popoverMode = this["popoverMode"] as PopoverMode;
      const termin = this["termin"] as Termin;
      return popoverMode == "block" || (termin && termin.geblockt);
    },
    terminHatZweiDamen() {
      const popoverMode = this["popoverMode"] as PopoverMode;
      const massageart = this["massageart"] as MassageArt;
      return popoverMode != "block" && massageart && massageart.zweiteDame;
    },
    maskeEditierbar() {
      switch (this.popoverMode) {
        case "create":
        case "beginnt":
        case "duplicate":
        case "block":
          return true;
        case "edit":
          return !(this as any)?.termin?.abgesagt;
      }
      return false;
    },
    gastGrundAenderbar() {
      switch (this.popoverMode) {
        case "create":
        case "beginnt":
        case "block":
          return true;
        case "edit":
          return !(this as any).termin?.abgesagt;
        default:
          return false;
      }
    },
    maskeReadOnly() {
      switch (this.popoverMode) {
        case "info":
        case "delete":
          return true;
        case "edit":
          return (this as any).termin?.abgesagt;
      }
      return false;
    },
    beginnable() {
      return (
        (this as any).popoverMode == "edit" &&
        !(this as any).termin?.abgesagt &&
        (this as any).isMobile &&
        moment((this as any).termin?.zeit)
          .format()
          .substring(0, 10) ==
          moment()
            .format()
            .substring(0, 10)
      );
    },
    deletable() {
      return (
        (this as any).popoverMode == "edit" &&
        !(this as any).termin?.abgesagt &&
        (this as any).isMobile
      );
    },
    zeitLesbar() {
      const zeit = (this as any).zeit;
      return (
        (zeit.getHours() < 10 ? "0" : "") +
        zeit.getHours() +
        " : " +
        (zeit.getMinutes() < 10 ? "0" : "") +
        zeit.getMinutes()
      );
    },
    dauerLesbar() {
      const dauer = (this as any).dauer;
      return (
        (dauer.getHours() < 10 ? "0" : "") +
        dauer.getHours() +
        " : " +
        (dauer.getMinutes() < 10 ? "0" : "") +
        dauer.getMinutes()
      );
    },
    terminartZeitValidationError() {
      const dauer = this.dauer.getHours() + this.dauer.getMinutes() / 60;
      if (dauer == 1.25) {
        const validationMessage = "75-Minuten-Termine können nicht gebucht werden.";
        console.log(validationMessage);
        return validationMessage;
      }
      if (this.massageart.validation) {
        const massageart: MassageArt = (this as any).massageart;
        console.log("Berechne Validierung für Massageart:");
        if (massageart.validation && !massageart.validation(dauer)) {
          if (massageart.validationMessage) {
            console.log(massageart.validationMessage);
            return massageart.validationMessage;
          } else {
            const validationMessage =
              massageart.name + " ist nur stundenweise buchbar";
            console.log(validationMessage);
            return validationMessage;
          }
        }
      } else {
        console.log("Diese Massageart braucht keine Validierung");
      }
      console.log("Validierung: Okay");
      return null;
    },
    preis() {
      const dauerDate = (this as any).dauer;
      const dauer = dauerDate.getHours() + dauerDate.getMinutes() / 60;
      return berechneMiete(
        {
          dauer,
          massageart: (this as any).massageart,
        } as Termin,
        true
      );
    },
    //formValid() {return this.terminHatZweiDamen},
  },
  watch: {
    preisManuell(neuerPreis: string) {
      if (neuerPreis.length) {
        const preisManuell = parseFloat(neuerPreis);
        const termin = { preisManuell } as Termin;
        this.zimmermieteManuell = berechneMiete(termin, false);
        this.verdienstDame = preisManuell - this.zimmermieteManuell;
      } else {
        const dauerDate = (this as any).dauer;
        const dauer = dauerDate.getHours() + dauerDate.getMinutes() / 60;
        const termin = { dauer, massageart: (this as any).massageart } as Termin;
        this.zimmermieteManuell = berechneMiete(termin, true);
        this.verdienstDame = vollerPreisDesTermins(termin) - this.zimmermieteManuell;
      }
    }
  },
  methods: {
    show(
      popoverMode: PopoverMode,
      dame: Dame | null,
      dame2: Dame | null,
      tag: string,
      zeitslot: number,
      termin: Termin | null
    ) {
      console.log(dame);
      this.popoverMode = popoverMode;
      this.isMobile = !isComputer();
      this.tag = tag;
      this.originalUhrzeit = termin?.originalUhrzeit;
      this.damenGefiltert = [...this.verfuegbareDamen] as Dame[];
      this.dame = (this.verfuegbareDamen as Dame[]).filter(
        (d) => dame && d && d.id == dame?.id
      )[0];
      this.dame2 =
        dame2 && dame2.id
          ? (this.verfuegbareDamen as Dame[]).filter(
              (d) => dame2 && d && d.id == dame2?.id
            )[0]
          : dame2;
      this.termin = termin;
      this.gast = termin && termin.gast ? termin.gast : "";
      this.massageart =
        termin && termin.massageart ? termin.massageart : massagearten[0];

      let refdate = moment(tag)
        .hour(0)
        .minute(0);
      this.minDate = new Date(refdate.unix() * 1e3);
      this.maxDate = new Date(refdate.add(1, "day").unix() * 1e3);

      if (termin) {
        const terminZeitpunkt = moment(termin.zeit);
        this.zeit = new Date(terminZeitpunkt.unix() * 1e3);
      } else {
        this.zeit = new Date(
          refdate
            .hour(zeitslot | 0)
            .minute((zeitslot - (zeitslot | 0)) * 60)
            .unix() * 1e3
        );
      }
      this.zeitLabel =
        popoverMode == "beginnt"
          ? "Uhrzeit (auf aktuelle Zeit gerundet)"
          : "Uhrzeit";
      const terminZeitpunkt = moment(this.zeit);
      console.debug("Termin ist um " + this.zeit.toString());

      this.dauer = new Date(
        refdate
          .hour(termin ? termin.dauer | 0 : 1)
          .minute(termin ? (termin.dauer * 60) % 60 : 0)
          .unix() * 1e3
      );
      this.minDauerDate = new Date(
        refdate
          .hour(0)
          .minute(30)
          .unix() * 1e3
      );
      refdate.add(1, "day"); // Am nächsten Morgen
      this.maxDauerDate = new Date(
        refdate
          .hour(6)
          .minute(0)
          .unix() * 1e3 // 6 Uhr am nächsten morgen
      );
      this.preisManuell = "" + (termin?.preisManuell || "");
      this.zimmermieteManuell = termin ? berechneMiete(termin, false) : 0;
      this.verdienstDame = termin ? ((this.preisManuell.length ? (termin.preisManuell || 0) : vollerPreisDesTermins(termin)) - this.zimmermieteManuell) : 0;

      refdate.hour(4).minute(0); // Termin endet spätestens irgendwann in der Nacht oder morgens am nächsten Tag
      //this.maxDate = new Date(refdate.unix() * 1e3);
      console.log("Min-Date: " + moment(this.minDate).format());
      console.log("Max-Date: " + moment(this.maxDate).format());

      switch (popoverMode) {
        case "info":
          if (termin?.geblockt) {
            this.popoverTitle = "Abwesenheit";
            this.popoverHinweistext = `<strong>${termin?.dame?.kuenstlername ||
              "?"}</strong> ist in folgendem Zeitraum abwesend, bzw. nicht verfügbar:`;
          } else {
            this.popoverTitle = "Termindetails";
            this.popoverHinweistext =
              "Folgende Informationen stehen für den gewählten Termin bereit:";
          }
          break;
        case "beginnt":
          this.popoverTitle = "Termin beginnen lassen";
          this.popoverHinweistext = `Bestätigen Sie die Uhrzeit, wann der Termin mit <strong>${
            termin?.dame?.kuenstlername
          }</strong> beginnt, bzw. begonnen hat.<br/>Ursprünglicher Termin war <u><strong>${terminZeitpunkt.format(
            "HH:mm"
          )}</strong></u>.`;
          this.originalUhrzeit = this.termin?.zeit;
          // Termin Startzeit verschieben auf volle Viertelstunde auf-/abrunden
          refdate = moment()
            .second(0)
            .millisecond(0);
          if (refdate.minute() % 15 < 7) {
            refdate.subtract(refdate.minute() % 15, "minutes");
          } else {
            refdate.add(15 - (refdate.minute() % 15), "minutes");
          }
          this.zeit.setHours(refdate.hours());
          this.zeit.setMinutes(refdate.minutes());
          break;
        case "edit":
          if (termin?.geblockt) {
            this.popoverTitle = "Abwesenheit bearbeiten";
            this.popoverHinweistext = `Dies ist eine geplante Abwesenheit von <strong>${termin?.dame?.kuenstlername}</strong>. Bitte passen Sie diese nur in direkter Absprache mit ihr an.`;
          } else {
            if (termin?.abgesagt) {
              this.popoverTitle = "Abgesagter Termin";
              this.popoverHinweistext =
                "Hier sehen Sie die Details zu dem einst vergebenen Termin";
            } else {
              this.popoverTitle = "Termin bearbeiten";
              this.popoverHinweistext =
                "Hier kann der Termin bearbeitet, jedoch nicht gelöscht oder verschoben werden";
            }
          }
          break;
        case "delete":
          this.popoverTitle = "Termin absagen";
          this.popoverHinweistext =
            "Möchten Sie folgenden Termin tatsächlich absagen?";
          break;
        case "duplicate":
          this.popoverTitle = "Duplikat/Wiederholung des Termins";
          this.popoverHinweistext =
            "Hiermit legen Sie einen neuen Termin an, der auf den Daten des ausgewählten Termins basiert.<br>Bitte wählen Sie einen freien Zeitpunkt und passen Sie ggfs. die Dauer an.";
          break;
        case "create":
          this.popoverTitle = `Neuer Termin bei ${dame?.kuenstlername}`;
          this.popoverHinweistext = `Hiermit stellen Sie ${dame?.kuenstlername} einen neuen Termin ein.`;
          break;
        case "block":
          this.popoverTitle = `${dame?.kuenstlername} blocken`;
          this.popoverHinweistext = `Hiermit markieren Sie ${dame?.kuenstlername} vorrübergehend als belegt.<br>In diesem Zeitraum werden Sie ihr keine Termine einstellen können.`;
          break;
        default:
          return;
      }
      switch (this.popoverMode) {
        case "info":
          this.popoverYesSaveButtonLabel = "Schließen";
          break;
        case "delete":
          this.popoverYesSaveButtonLabel = "Absagen";
          break;
        default:
          if (this.popoverMode == "edit" && this.termin?.abgesagt) {
            this.popoverYesSaveButtonLabel = "Schließen";
          } else {
            this.popoverYesSaveButtonLabel = "Speichern";
          }
      }

      this.showPopover = true;
    },

    // Suchverhalten für Autocomplete
    searchDame1(param: { originalEvent: any; query: string }) {
      setTimeout(() => {
        const query = param.query.toLowerCase();
        const dame2Id = this.dame2 && this.dame2.id ? this.dame2.id : -1;
        this.damenGefiltert = (this.verfuegbareDamen as Dame[]).filter(
          (d) =>
            d &&
            d.id != dame2Id &&
            d.kuenstlername.toLowerCase().indexOf(query) > -1
        );
      }, 200);
    },
    searchDame2(param: { originalEvent: any; query: string }) {
      setTimeout(() => {
        const query = param.query.toLowerCase();
        const dame1Id = this.dame && this.dame.id ? this.dame.id : -1;
        this.damenGefiltert = (this.verfuegbareDamen as Dame[]).filter(
          (d) =>
            d &&
            d.id != dame1Id &&
            d.kuenstlername.toLowerCase().indexOf(query) > -1
        );
      }, 200);
    },
    clearDamenFilter() {
      //this.damenGefiltert = [...this.verfuegbareDamen] as Dame[];
    },

    // Behandeln von Eingabemasken/Dialog für
    // Neuanlage/Bearbeitung/Sperrung/Löschung
    popoverYesSave() {
      this.showPopover = false;
      if (this.popoverMode != "info") {
        this.$emit("update", {
          popoverMode: this.popoverMode,
          termin: {
            id: this.termin?.id,
            gast: this.gast,
            massageart: this.massageart,
            dame: this.dame,
            dame2: this.dame2,
            zeit: moment(this.tag)
              .hour(this.zeit.getHours())
              .minute(this.zeit.getMinutes())
              .format(),
            dauer: this.dauer.getHours() + this.dauer.getMinutes() / 60,
            abgesagt: this.termin?.abgesagt,
            geblockt: this.termin?.geblockt,
            originalUhrzeit: this.originalUhrzeit,
            preisManuell: this.preisManuell.length
              ? parseInt(this.preisManuell)
              : undefined,
          } as Termin,
        } as TerminUpdateEvent);
      }
    },
    terminBeginnt() {
      this.show("beginnt", this.dame, this.dame2, this.tag, -1, this.termin);
    },
    popoverDelete() {
      this.popoverMode = "delete";
      this.originalUhrzeit = this.termin?.originalUhrzeit;
      this.popoverYesSave();
    },
    popoverNoAbort() {
      this.showPopover = false;
    },
  },
});
